// Pagination
import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import * as l from './_csLcl';

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';
import * as TextC from './_ccbTextC';

//import { useAny } from './_csLcl';

const _grtCrtIdx = (pnCrtPage: ht.n, pnCntPerPage: ht.n) => {
  const _dz = {
    nCrtIdxStt: (pnCrtPage - 1) * pnCntPerPage,
    nCrtIdxEnd: (pnCrtPage) * pnCntPerPage - 1,
  };
//console.log(`Pnn 196: ${pnCrtPage}, ${pnCntPerPage}, ` + hf.s(_dz))
  return _dz;
};

const _moveToFstPage = (psPnnz: ht.dz) => {
  const _nCrtPage = 1;
  psPnnz.set({
    ... _grtCrtIdx(_nCrtPage, psPnnz.nCntPerPage),
    nCrtPage: _nCrtPage,
  })
};

const _moveToPvsPage = (psPnnz: ht.dz) => {
  let _nCrtPage = psPnnz.crt.nCrtPage - 1;
  if ( _nCrtPage < 1 ) {
    _nCrtPage = 1;
  }
  psPnnz.set({
    ... _grtCrtIdx(_nCrtPage, psPnnz.crt.nCntPerPage),
    nCrtPage: _nCrtPage,
  })
};

const _moveToNextPage = (psPnnz: ht.dz) => {
  let _nCrtPage = psPnnz.crt.nCrtPage + 1;
  if ( _nCrtPage > psPnnz.crt.nTtlPage ) {
    _nCrtPage = psPnnz.crt.nTtlPage;
  }
  psPnnz.set({
    ... _grtCrtIdx(_nCrtPage, psPnnz.crt.nCntPerPage),
    nCrtPage: _nCrtPage,
  })
};

const _moveToLastPage = (psPnnz: ht.dz) => {
  const _nCrtPage = psPnnz.crt.nTtlPage;
  psPnnz.set({
    ... _grtCrtIdx(_nCrtPage, psPnnz.crt.nCntPerPage),
    nCrtPage: _nCrtPage,
  })
};

const PnnC = React.memo((pz: ht.pnnCz) => {

  /*
  const _snCntPerPage = useAny(100);
  const _snCrtPage = useAny(0);
  const _snLastPage = useAny(0);
  const _snTtlCnt = useAny(0);
  */

  const _sPnnz = l.useDz({
    nTtlCnt: 0,
    nCntPerPage: 10,
    nCrtPage: 1,
    nTtlPage: 1,
    nCrtIdxStt: 0,
    nCrtIdxEnd: 9,
  });

  React.useEffect(() => {
    _sPnnz.set({
      nTtlCnt: pz.cz.nTtlCnt,
      nCntPerPage: pz.cz.nCntPerPage,
      nCrtPage: 1,
      nTtlPage: hf.cvtCeil((pz.cz.nTtlCnt > 0 ? pz.cz.nTtlCnt : 1) / (pz.cz.nCntPerPage ?? 10)),
      nCrtIdxStt: 0,
      nCrtIdxEnd: pz.cz.nCntPerPage - 1,
    });
  }, [
    pz.cz.nTtlCnt,
    pz.cz.nCntPerPage,
  ]);

  React.useEffect(() => {
    pz.cz.onChg(_sPnnz.crt);
  }, [
    _sPnnz.crt.nCrtIdxStt,
    _sPnnz.crt.nCrtIdxEnd
  ]);

  if ( _sPnnz.crt.nTtlPage == 1 ) return null;

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.pnnAbtz[_abtType] ? ica.pnnAbtz[_abtType]() : {};

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      oClds: [
        cr.c(LblC.N, { // 表示順
          key: -70,
          abtType: 'none',
          textz: {
            pfx: 'order',
            stlz: _abtz?.odrz?.textz.stlz,
          },
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: true,
                type: 'pcr',
                ls: [
                  { key: 10, pfx: 'clm1' },
                  { key: 20, pfx: 'clm2' },
                ],
              },
              iptStlz: {
                editz: _abtz?.odrz?.iptStlz?.editz,
                showz: _abtz?.odrz?.iptStlz?.showz,
              },
            })
          ],
          boxStlz: _abtz?.odrz.boxStlz
        }),
        cr.c(LblC.N, { // 表示件数
          key: -10,
          abtType: 'none',
          textz: {
            pfx: 'lines',
            stlz: _abtz.linez.textz.stlz,
          },
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: true,
                type: 'pcr',
                ls: [
                  { key:  50, pfx:  '50' },
                  { key: 100, pfx: '100' },
                ],
              },
              iptStlz: {
                editz: _abtz?.linez?.iptStlz?.editz,
                showz: _abtz?.linez?.iptStlz?.showz,
              },
            })
          ],
          boxStlz: _abtz.linez.boxStlz
        }),
        cr.c(BtnC.N, {
          key: -20,
          abtType: 'none',
          bfrIconCz: {
            iconPtyz: _abtz.fstz.iconPtyz
          },
          boxStlz: _abtz.fstz.boxStlz,
          pslPtyz: {
            onPress: () => _moveToFstPage(_sPnnz),
          }
        }),
        cr.c(BtnC.N, {
          key: -30,
          abtType: 'none',
          bfrIconCz: {
            iconPtyz: _abtz.pvsz.iconPtyz
          },
          boxStlz: _abtz.pvsz.boxStlz,
          pslPtyz: {
            onPress: () => _moveToPvsPage(_sPnnz),
          }
        }),
        cr.c(TextC.N, {
          key: -40,
          textz: {
            pfx: `${_sPnnz.crt.nCrtPage} / ${_sPnnz.crt.nTtlPage}`,
            stlz: _abtz.nbrz.textz.stlz,
          }
        }),
        cr.c(BtnC.N, {
          key: -50,
          abtType: 'none',
          cz: {
          },
          bfrIconCz: {
            iconPtyz: _abtz.nextz.iconPtyz
          },
          boxStlz: _abtz.lastz.boxStlz,
          pslPtyz: {
            onPress: () => _moveToNextPage(_sPnnz),
          }
        }),
        cr.c(BtnC.N, {
          key: -60,
          abtType: 'none',
          bfrIconCz: {
            iconPtyz: _abtz.lastz.iconPtyz
          },
          boxStlz: _abtz.lastz.boxStlz,
          pslPtyz: {
            onPress: () => _moveToLastPage(_sPnnz),
          }
        }),
      ]
    })

  )
});

export const N = PnnC;
